import styled from "styled-components";

const Container = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 2rem 1.25rem;
`;

export default Container;
